var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import styled, { css } from 'styled-components';
import { Button } from '../../../../components/Button';
import { device } from '../../../../components/GlobalHeader/breakpoints';
export var StyledClaimsButton = styled(Button)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  height: 40px;\n  width: 100%;\n\n  @media ", " {\n    height: 48px;\n    ", "\n  }\n"], ["\n  height: 40px;\n  width: 100%;\n\n  @media ", " {\n    height: 48px;\n    ", "\n  }\n"])), device.laptop, function (_a) {
    var accountMenuActive = _a.accountMenuActive;
    return accountMenuActive && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        width: 50%;\n      "], ["\n        width: 50%;\n      "])));
});
export var ClaimsButton = function (props) {
    return (React.createElement(StyledClaimsButton, __assign({}, props, { variant: "default" }), props.label || 'Claims'));
};
var templateObject_1, templateObject_2;
